import { render } from "./Copyright.vue?vue&type=template&id=494f376f&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"

import "./Copyright.vue?vue&type=style&index=0&id=494f376f&scoped=true&lang=scss"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494f376f"]])

export default __exports__